import { CareersService } from "@vahak/core/dist/_services/careers.service";
import { useDefaultTopLayout } from "components/layout/layout-methods";

export const MAX_JOBS_PER_PAGE = 6;

export const REVALIDATE_TIME = 7 * 24 * 60 * 60; // 7 days

/***
 * Careers Home Page Methods
 */
export const getCareerHomePageStaticProps = async () => {
    return {
        ...(await CareersService.getAllJobs({ page: 1, limit: MAX_JOBS_PER_PAGE })),
        ...(await CareersService.getAllCategories()),
        revalidate: REVALIDATE_TIME
    };
};

export const getCareersHomePageLayout = useDefaultTopLayout;

/***
 * Careers Job Post Page Methods
 */
export const getCareerJobPostStaticProps = async (slug: string) => {
    return { data: await CareersService.getJobBySlug({ slug }), slug, revalidate: REVALIDATE_TIME };
};

export const getCareersJobPostPageLayout = useDefaultTopLayout;

export const getCareerJobPostStaticPaths = async () => {
    const { meta } = await CareersService.getAllJobs({ page: 1 });
    const { jobs } = await CareersService.getAllJobs({ page: 1, limit: meta?.pagination.total });
    let paths = jobs?.reduce((paths: any, post: any) => {
        let tempObj: any = {};
        tempObj["params"] = { jobPost: post.slug };
        paths.push(tempObj);
        return paths;
    }, []);
    return { paths, fallback: "blocking" };
};
